export enum SearchParam {
  Seat = 'seat',
  SetupIntentClientSecret = 'setup_intent_client_secret',
  SetupIntent = 'setup_intent',
  RedirectStatus = 'redirect_status',
  SubscriptionId = 'subscription_id',
}
